"use strict";
"use client";

import React from 'react';
import styles from './GlobalBackground.module.css';

const GlobalBackground: React.FC = () => {
    return (
        <div className={styles.backgroundContainer}>
            <div className={styles.glowLeft} />
            <div className={styles.glowRight} />
        </div>
    );
};

export default GlobalBackground;
